(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ace-theme-toggle"] && !Shopify.designMode) return;
  try {
    class AceThemeToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.media = window.matchMedia('(prefers-color-scheme: dark)');

        this.onClick = this.onClick.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);

        this.button.addEventListener('click', this.onClick);
        this.media.addEventListener('change', this.onMediaChange);

        this.syncLabel();
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.onClick);
        this.media.removeEventListener('change', this.onMediaChange);
      }

      get isDark() {
        return document.documentElement.getAttribute('data-theme') === 'dark';
      }

      apply(isDark, mode) {
        const root = document.documentElement;
        root.setAttribute('data-theme', isDark ? 'dark' : 'light');
        root.setAttribute('data-theme-mode', mode);
        this.syncLabel();
      }

      syncLabel() {
        const label = this.isDark
          ? this.dataset.labelLight
          : this.dataset.labelDark;
        this.button.setAttribute('aria-label', label);
        this.button.setAttribute('aria-pressed', String(this.isDark));
      }

      onClick() {
        const next = this.isDark ? 'light' : 'dark';
        try {
          localStorage.setItem('theme', next);
        } catch (e) {}
        this.apply(next === 'dark', next);
      }

      onMediaChange(event) {
        // Only follow the OS when the effective mode is 'auto': the visitor hasn't
        // made an explicit choice AND the merchant default is 'auto'. A forced
        // 'light'/'dark' default must not be overridden by an OS theme change.
        let stored = null;
        try {
          stored = localStorage.getItem('theme');
        } catch (e) {}
        if (stored === 'light' || stored === 'dark') return;
        if ((this.dataset.defaultMode || 'auto') !== 'auto') return;
        this.apply(event.matches, 'auto');
      }
    }

    if (!customElements.get('ace-theme-toggle')) {
      customElements.define('ace-theme-toggle', AceThemeToggle);
    }
  } catch(e) { console.error(e); }
})();

})();
